import { render, staticRenderFns } from "./FormularioPerfilComponent.vue?vue&type=template&id=35f5760c"
import script from "./FormularioPerfilComponent.vue?vue&type=script&lang=js"
export * from "./FormularioPerfilComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports